import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  container: {
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 24,
    '& .checkbox-label span': {
      fontWeight: '700',
      fontFamily: 'Roboto',
      fontSize: 15,
    }
  },

  tableContainer: {
    padding: '16px 8px',
    maxWidth: '100%',
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    minWidth: 'max-content',
    fontFamily: 'Roboto',
    '& th': {
      height: 24,
      background: '#F7F6F7',
      textAlign: 'left',
      padding: '0 16px',
      fontSize: 12,
      fontWeight: 500,
      color: '#79797D',
      verticalAlign: 'middle',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    },
  },
  tableCell: {
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8,
    verticalAlign: 'top',
    borderBottom: '1px solid #E1E2EA',
    '& .MuiOutlinedInput-root': {
      height: 34,
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    '&.error textarea': {
      borderColor: '#ff0000',
    },
    '&.error .MuiOutlinedInput-root': {
      border: '1px solid #ff0000',
    },
  },
  inputField: {
    minHeight: 34,
    width: 430,
    borderRadius: 4,
    border: '1px solid #AAA2AA',
    resize: 'none', // Removes the dragging icon from the corner
    overflow: 'hidden', // Ensures the content doesn't overflow
  },
  select: {
    color: '#545964',
    fontSize: 14,
    fontWeight: 400,
    fontFamily: 'Roboto',
    '& .placeholder': {
      color: '#80848D',
    },
  },

  checkboxLabelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  }
}));

export default useStyles;
